import React from "react";
import { Link } from 'react-router-dom'
import { TFunction } from "i18next";
import { makeAuditPageHref, makeEditAuditPageHref } from "../../../utils/auditoinnit.helpers";
import { AuditStatusLabel } from "../audit/AuditStatusLabel";
import { IConfiguredComponents } from "../../../configuration/Components";
import { EvaluationsSummary } from "../../form/EvaluationsSummary";
import { RenderFormType } from "../../formType/RenderFormType";
import { FormCategoryIcon } from "../../formType/FormCategoryIcon";
import { EAuditStatus } from "../../../interfaces/IAudit";


const getTextProps = (t: TFunction) => ({
    audit: t("Auditointi"),
    status: t("Tila"),
    location: t("Sijainti"),
    responsiblePerson: t("Vastuuhenkilö"),
    summary: t("Yhteenveto"),
});

type ColumnProps = {
    texts: ReturnType<typeof getTextProps>;
    LocationName: IConfiguredComponents["LocationName"],
    PersonName: IConfiguredComponents["PersonName"]
};

type ColumnFn = (props: ColumnProps) => any



const makeTitleColumn: ColumnFn = ({ texts }) => ({
    Header: texts.audit,
    accessor: "title",
    id: "audit-name",
    Cell: ({
        row: { original },
        cell: { value: title }
    }: any) => (
        <div className="audit-title">
            <div style={{ marginRight: "10px" }}>
                {original.formType ? (
                    <RenderFormType formTypeId={original.formType}
                        render={({ formType }) => (
                            <FormCategoryIcon
                                categoryId={formType.category}
                                color="green"
                            />
                        )}
                    />
                ) : null}
            </div>
            <Link
                to={original.status === EAuditStatus.Draft ? makeEditAuditPageHref(original.guid, false, true) : makeAuditPageHref(original.guid)}
                style={{ fontWeight: "bold" }}
                children={title}
            />
        </div>

    )
});

const makeStatusColumn: ColumnFn = ({ texts }) => ({
    Header: texts.status,
    accessor: "status",
    id: "audit-status",
    Cell: ({ row, cell: { value: status } }: any) => (
        <div style={{ minWidth: "100px" }}>
            <AuditStatusLabel
                as={"small"}
                status={status}
            />
        </div>
    )
});

const makeLocationColumn: ColumnFn = ({ texts, LocationName }) => ({
    Header: texts.location,
    accessor: "target",
    id: "audit-target",
    Cell: ({ row, cell: { value: locationId } }: any) => (
        <div className="truncate" style={{ width: "260px" }} >
            {locationId ? <LocationName locationId={locationId} /> : null}
        </div>
    )
});

const makeResponsiblePersonColumn: ColumnFn = ({ texts, PersonName }) => ({
    Header: texts.responsiblePerson,
    accessor: "metaData",
    id: "audit-responsible-person",
    Cell: ({ row, cell: { value: { responsiblePerson } } }: any) => {

        return (
            <div className="truncate" style={{ width: "160px" }}>
                { responsiblePerson ? <PersonName personId={responsiblePerson} /> : null}
            </div>
        )
    }
});

const makeSummaryColumn: ColumnFn = ({ texts }) => ({
    Header: texts.summary,
    accessor: "statics",
    id: "audit-statics",
    Cell: ({ row, cell: { value: statics } }: any) => (
        <div style={{ width: "200px", minHeight: "43px" }} >
            {statics ? <EvaluationsSummary data={statics} /> : null}
        </div>
    )
});



const createColumns = (
    t: TFunction,
    LocationName: IConfiguredComponents["LocationName"],
    PersonName: IConfiguredComponents["PersonName"],
    showColumns = true
) => {
    const texts = getTextProps(t);

    const columnProps: ColumnProps = {
        texts,
        LocationName,
        PersonName
    };

    const columns = [
        makeTitleColumn(columnProps),
        makeStatusColumn(columnProps),
        makeLocationColumn(columnProps),
        makeResponsiblePersonColumn(columnProps),
    ];

    if (showColumns) {
        columns.push(makeSummaryColumn(columnProps));
    }

    return columns;

};

export default createColumns